module.exports = __webpack_public_path__ + "static/media/icon.4c05c24b.svg";